import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeadPartnersComponent } from './lead-partners.component';
import { PartnersListComponent } from './partners-list/partners-list.component';
import { PartnersAddEditComponent } from './partners-add-edit/partners-add-edit.component';
import { EditLeadPartnerContentComponent } from './edit-lead-partner-content/edit-lead-partner-content.component';
import { EditLeadPartnerPopupContentComponent } from './edit-lead-partner-popup-content/edit-lead-partner-popup-content.component';
import { LeadPartnerPerformanceListComponent } from './lead-partner-performance-list/lead-partner-performance-list.component';
import { LeadPartnerPerformanceDetailsComponent } from './lead-partner-performance-details/lead-partner-performance-details.component';
import { PartnerDashbaordComponent } from './partner-dashbaord/partner-dashbaord.component';

const routes: Routes = [
  {
    path: '',
    component : LeadPartnersComponent,
    children: [
      {
        path: 'partner-list',
        component: PartnersListComponent
      },
      {
        path: 'partner-add',
        component: PartnersAddEditComponent
      },
      {
        path: 'partner-edit/:partnerId',
        component: PartnersAddEditComponent
      },
      {
        path: 'partner-content-edit/:id',
        component: EditLeadPartnerContentComponent
      },
      {
        path: 'partner-popup-content-edit/:id',
        component: EditLeadPartnerPopupContentComponent
      },
      {
        path: 'lead-partner-performance-list',
        component: LeadPartnerPerformanceListComponent
      },
      {
        path: 'lead-partner-performance-details/:id',
        component: LeadPartnerPerformanceDetailsComponent
      },
      {
        path: 'lead-partner-dashboard/:id',
        component: PartnerDashbaordComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeadPartnersRoutingModule { }
